// src/hooks/menu/useMenuSEO.js
import { useEffect } from 'react';
import { formatCategory } from '../../util';
import { filterTypes } from '../../config';

export const useMenuSEO = ({
    selectedFilters,
    filterTerms,
    retailerName,
    seoGeos
}) => {
    // Update document title based on filters
    useEffect(() => {
        const categoryFilterText = selectedFilters[filterTypes.category] 
            ? formatCategory(selectedFilters[filterTypes.category]) 
            : '';
            
        let brandNameText = '';
        if (selectedFilters.brandIds?.length > 0 && filterTerms.brands) {
            brandNameText = filterTerms.brands.find(
                b => b && b.id === selectedFilters.brandIds[0]
            )?.name || '';
        }
        
        let title;
        if (brandNameText) {
            title = `Shop ${brandNameText} | ${seoGeos ? `${seoGeos} | ` : ''}${retailerName}`;
        } else if (categoryFilterText) {
            title = `Shop ${categoryFilterText} | ${seoGeos ? `${seoGeos} | ` : ''}${retailerName}`;
        } else {
            title = `Order Cannabis Online ${seoGeos ? `in ${seoGeos} ` : ''} | ${retailerName}`;
        }
        
        document.title = title;
    }, [retailerName, seoGeos, selectedFilters, filterTerms.brands]);
};
